// apps/web/src/routes/conversations.tsx
import { ConversationSidebar } from '../components/conversation-sidebar'
import { MessageList } from '../components/message-list'
import { MessageInput } from '../components/message-input'
import { useChatStore } from '../stores/chat-store'

export function ConversationsPage() {
  const { activeConversationId } = useChatStore()

  return (
    <div className="flex h-full">
      <ConversationSidebar />

      <div className="flex flex-1 flex-col">
        {activeConversationId ? (
          <>
            <MessageList conversationId={activeConversationId} />
            <MessageInput conversationId={activeConversationId} />
          </>
        ) : (
          <div className="flex flex-1 items-center justify-center text-slate-400">
            <div className="text-center">
              <p className="text-4xl mb-3">💬</p>
              <p>Chọn một hội thoại để bắt đầu</p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
